export const formatNumber = (number: number) => {
  return Intl.NumberFormat('en-US').format(number)
}

export const formatCurrency = (
  value: number,
  currency: string,
  locale: string
): string => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(value)
}

export const getCurrencyDenominator = (currencyCode: string): number => {
  const formatter = new Intl.NumberFormat('en', {
    style: 'currency',
    currency: currencyCode,
  })
  const fractionDigits = formatter.resolvedOptions().minimumFractionDigits
  return Math.pow(10, fractionDigits || 0)
}
